<template>
  <full-page-shell
    class="login-el-outer"
  >
    <template v-if="!ajaxSuccsss">
      <h3 class="title">{{$t('resetPass')}}</h3>
      <p class="tips">{{$t('Your_new_password_must_be_different_from_your_old_password')}}</p>
      <div class="tab-nav">
        <div
          class="tab-item"
          :class="{on: tabName == 'phone'}"
          @click="tabHandle('phone')"
        >{{$t('Login.phoneVer')}}</div>
        <div
          class="tab-item"
          :class="{on: tabName == 'email'}"
          @click="tabHandle('email')"
        >{{$t('Login.emailVer')}}</div>
      </div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        hide-required-asterisk
      >
        <el-form-item
          v-if="tabName == 'phone'"
          :label="$t('mobile_phone')"
          key="phone"
          prop="phone"
          class="phone-form-item no-need-border-radiu"
        >
          <el-input
            :placeholder="$t('please_enter')"
            v-model="form.phone"
            name="phone"
            class="w-full">
            <el-select
              slot="prepend"
              :placeholder="$t('root.selectPls')"
              v-model="form.phoneTitle"
              style="width: 100px"
              filterable
            >
              <el-option
                v-for="(option,index) in phoneList"
                :key="index"
                :label="option.label"
                :value="option.label"
              >
                <span>{{`${option.label} ${option.description}`}}</span>
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="tabName == 'email'"
          :label="$t('email')"
          key="email"
          prop="email"
        >
          <el-input
            :placeholder="$t('please_enter')"
            v-model="form.email"
            name="email"
            class="w-full">
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('Verification_Code')"
          prop="verCode"
        >
          <div class="code-box pr">
            <el-input
              :placeholder="$t('please_input')"
              v-model="form.verCode"
              class="w-full"
            ></el-input>
            <span
              class="code-btn-text active pa"
              v-if="isCode"
              @click="getCode"
            >{{$t('Send_verification_code')}}</span>
            <span class="code-btn-text pa" v-if="!isCode">{{isCodeNumber}}s {{$t('Register.againVer')}}</span>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('User.newPass')"
          prop="newPsw"
          :show-message="false"
          class="has-text-content"
        >
          <el-input
            v-model="form.newPsw"
            show-password
            maxlength="20"
            :placeholder="$t('please_input')"
          ></el-input>
          <p class="pass-strong-level one-level"
             :class="{
                            on: oneLevelFlag == true,
                           nopass: oneLevelFlag == false,
                       }"
          >
            <span class="circle pass-strong-circle"></span>
            <span>{{$t('limitRegistPassOneStep')}}</span>
          </p>
          <p class="pass-strong-level two-level"
             :class="{
                       on: twoLevelFlag,
                            nopass: twoLevelFlag == false,
                       }"
          >
            <span class="circle pass-strong-circle"></span>
            <span>{{$t('limitRegistPassTwoStep')}}</span>
          </p>
        </el-form-item>
        <el-form-item
          :label="$t('Register.rePswText')"
          prop="rePsw"
        >
<!--          type="password"-->
          <el-input

            v-model="form.rePsw"
            show-password
            maxlength="20"
            :placeholder="$t('please_input')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <vs-button
            class="w-full mt-6"
            color="primary"
            type="filled"
            size="large"
            @click="resetPassHandle"
          >{{$t('resetPass')}}</vs-button>
        </el-form-item>
      </el-form>
      <div class="go-login center">
        <span
          class="pointer"
          @click="toLogin"
        >{{$t('Return_to_login')}}</span>
      </div>
      <vs-divider/>
      <div class="site-info display-flex justify-center">
        <span>COPYRIGHT &copy; {{ new Date().getFullYear() }}</span>
        <!--            {{config.siteName}}-->
      </div>
    </template>
    <template v-else>
      <div class="reset-success center">
        <p class="ajax-success-title blod">{{$t('Login.successSetPwd')}}</p>
        <p class="ajax-success-subtitle">{{$t('Please_keep_your_password_properly')}}</p>
        <vs-button
          class="w-full mt-6 reset-succsee-btn"
          color="primary"
          type="filled"
          @click="nowlogin"
        >{{$t('log_in_immediately')}}</vs-button>
        <p class="auto-login-tip"><span class="theme-color">{{countDown}}s</span>{{$t('log_in_automatically_after')}}</p>
        <vs-divider/>
        <div class="site-info display-flex justify-center">
          <span>COPYRIGHT &copy; {{ new Date().getFullYear() }}</span>
          <!--            {{config.siteName}}-->
        </div>
      </div>
    </template>
  </full-page-shell>
</template>

<script>
import { forgetVerification, forgetSubmit } from '@/api/user.js';
import { getDictListByType } from '@/api/home.js';
import { strongPwd, isMobile,validatEmail, passFisrtStrong, passSecondStrong } from '@/utils/validate';
import fullPageShell from "@/components/public/fullPageShell";
export default{
    components:{
      fullPageShell,
    },
  data() {
    let _this = this;
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('please_input_your_email')));
      } else {
        if (!validatEmail(value)) {
          callback(new Error(_this.$t('Register.errorMail')));
        } else {
          callback();
        }
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('phoneEmtpyTips')));
      } else {
        if (!isMobile(value)) {
          callback(new Error(_this.$t('Register.errorPhon')));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('Register.notpassword')));
      } else {
        if (!strongPwd(value)) {
          callback(new Error(_this.$t('Register.passwordDes')));
        } else {
          callback();
        }
      }
    };
    return {
      isCode: true,
      isCodeNumber: 60,
      tabName: 'phone',
      phoneList: [],

      form:{
        phoneTitle: '+86',
        phone: '',
        email: '',
        verCode: '',
        newPsw: '',
        rePsw: '',
      },
      rules:{
        phoneTitle: [
          { required: true, message: _this.$t('root.selectPls'), trigger: 'change' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        verCode: [
          { required: true, message: _this.$t('Partner.inputVer'), trigger: 'blur' }
        ],
        newPsw: [
          { validator: validatePass, trigger: 'blur' }
        ],
      },

      ajaxSuccsss: false,
      countDown: 3,
      countDownTimer: null,
    }
  },
  computed:{
    oneLevelFlag(){
      if(this.form.newPsw !== ''){
        return passFisrtStrong(this.form.newPsw);
      }
    },
    twoLevelFlag(){
      if(this.form.newPsw !== ''){
        return passSecondStrong(this.form.newPsw);
      }
    },
  },
  created(){
     this.getDictListByType();
  },
  methods: {
    getDictListByType(){
      let parmas = {
        type: 'phoneList'
      };
      getDictListByType(parmas).then((res) => {
        this.phoneList = res.data;
      });
    },
    tabHandle(tabName){
      this.tabName = tabName;
    },
    resetPasswordHandle() {
      this.$router.push({name: 'resetPassword'});
    },
    getCode() {
      console.log('1');
      this.$refs.form.validateField(['phone', 'email'], (res) => {
        if (!res) {
          let parmas = {
            verType: this.tabName == 'phone' ? 1: 2,
            acc: this.tabName == 'phone' ? this.form.phone : this.form.email
          };
          forgetVerification(parmas).then((res) => {
            this.$message({
              message: this.$t('User.verCodeSendSuccess'),
              type: 'success'
            });
            this.isCode = false;
            this.timerOut();
          });
        }
      });
    },
    timerOut() {
      let _this = this;
      let timer1 = setTimeout(() => {
        clearTimeout(timer1);
        if (_this.isCodeNumber > 0) {
          _this.isCodeNumber = --_this.isCodeNumber;
          _this.timerOut();
        } else {
          clearTimeout(timer1);
          this.isCode = true;
          this.isCodeNumber = 60;
        }
      }, 1000);
    },
    resetPassHandle(){
      this.$refs.form.validate((valid) => {
        if(valid){
          let parmas = {
            verType: this.tabName == 'phone' ? 1: 2,
            acc: this.tabName == 'phone' ? this.form.phone : this.form.email,
            verCode: this.form.verCode,
            pwd: this.$md5(this.form.rePsw)
          };
          forgetSubmit(parmas).then((res) => {
            this.ajaxSuccsss = true;
            //倒计时
            this.countDownTimer = setInterval(() => {
              if(this.countDown == 1){
                clearInterval(this.countDownTimer);
                this.$router.push({name: 'login'});
              }
              this.countDown--;

            },1000)
          }).catch((error) => {
            console.log(error);
          })
        }else {
          console.log('no-pass');
        }
      });
    },
    toLogin(){
      this.$router.push({name: 'login'});
    },
    nowlogin(){
      // 立即登陆
      this.$router.push({name: 'login'});
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/variable.scss";
  .login-el-outer {
    /deep/ .el-input__inner {
      border: 1px solid #D8D6DE;
      border-radius: 5px;
    }
    /deep/ .el-form-item__content {
      line-height: 10px;
      &.has-text-content {
        //line-height: 40px;
      }
    }
    /deep/ .el-form-item {
      margin-bottom: 15px;
    }
    /deep/ .el-form-item__label {
      padding-bottom: 5px;
      line-height: 14px;
    }
    .text-p {
      margin-bottom: 7px;
      margin-top: 7px;
    }
    .pass-strong-level {
      margin-top: 10px;
    }
    .tips {
      margin-bottom: 40px;
      margin-top: 10px;
    }
    .tab-nav {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      .tab-item {
        margin-right: 30px;
        padding-bottom: 10px;
        cursor: pointer;
        &.on {
          color: $themeColor;
          border-bottom: 2px solid $themeColor;
        }
      }
    }

    .code-box {
      .code-btn-text {
        position: absolute;
        right: 10px;
        bottom: 16px;
        //transform: translateY(50%);
        cursor: pointer;
        color: $themeColor;
      }
    }

    // 重置成功
    .reset-success {
      .ajax-success-title {
        font-size:  18px;
        margin-bottom: 5px;
      }
      .ajax-success-subtitle {
        margin-bottom: 20px;
      }
      .auto-login-tip {
        margin-top: 10px;
        margin-bottom: 30px;
      }
    }
  }
</style>
<style lang="scss">
.login-el-outer .no-need-border-radiu {
  .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
